module.exports = __webpack_public_path__ + "media/images/workplace/activity_points/shining_star_fx-5994adcdc01c7b87aafb4a3a2b2f8553.svg";